var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackArrowBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_216_100)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.667 6.99996C16.667 6.53972 16.2473 6.16663 15.7295 6.16663H2.60449C2.08672 6.16663 1.66699 6.53972 1.66699 6.99996C1.66699 7.4602 2.08672 7.83329 2.60449 7.83329H15.7295C16.2473 7.83329 16.667 7.4602 16.667 6.99996Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.58893 0.577452C7.26349 0.252015 6.73586 0.252015 6.41042 0.577452L0.577086 6.41078C0.251649 6.73622 0.251649 7.26386 0.577086 7.5893L6.41042 13.4226C6.73586 13.7481 7.26349 13.7481 7.58893 13.4226C7.91437 13.0972 7.91437 12.5696 7.58893 12.2441L2.34485 7.00004L7.58893 1.75596C7.91437 1.43053 7.91437 0.902889 7.58893 0.577452Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_216_100"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowBlack);
export default __webpack_public_path__ + "static/media/backArrowBlack.d43c7a9c362c7fbc7cdd19e120756da6.svg";
export { ForwardRef as ReactComponent };